// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCIg6WSokm-ZXzIuGGMUdktN8L8jet8a4A",
    authDomain: "web-inmaculada-de51e.firebaseapp.com",
    projectId: "web-inmaculada-de51e",
    storageBucket: "web-inmaculada-de51e.appspot.com",
    messagingSenderId: "916049518524",
    appId: "1:916049518524:web:6fafd8d9c089dea7eb15b9",
    measurementId: "G-55LX8235FV", // usar cuano se usa Analytics
};

const app = initializeApp(firebaseConfig);

// Exporta la instancia de Firestore y Storage
export const db = getFirestore(app);
export const storage = getStorage(app);
